import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDislike = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.3604 4H6C4.89543 4 4 4.89543 4 6V14H7.92963C8.59834 14 9.2228 14.3342 9.59373 14.8906L12.1094 18.6641C12.6658 19.4987 13.6025 20 14.6056 20H14.8195C15.4375 20 15.9075 19.4451 15.8059 18.8356L15 14H18.5604C19.8225 14 20.7691 12.8453 20.5216 11.6078L19.3216 5.60777C19.1346 4.67292 18.3138 4 17.3604 4Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 14V4",
		stroke: "currentColor",
		strokeWidth: 1.5
	})]
});
export default SvgDislike;
